$('.modal[data-open=onload]').each(function () {
    let bsModal = new bootstrap.Modal(this, {});
    bsModal.show()
})